export default "__VITE_ASSET__0940a257__"